import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Navbar from '../partials/navbar';
import Footer from '../partials/footer';

import 'tachyons/css/tachyons.css';
// import './index.css';

const TemplateWrapper = ({ children }) => (
  <div className="sans-serif">
    <Helmet
      title="Mark & Fastighetsteknik | Westpoint"
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <Navbar />
    {children()}
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js